module.exports = __webpack_public_path__ + "media/images/captive_portal/check-87b04719289a1cda3bc550429b2c67cf.svg";